import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Modal from "react-bootstrap/Modal";
import Button from "@mui/material/Button";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";
import DownloadIcon from '@mui/icons-material/Download';

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

const ExcelPreviewModal = ({ open, onClose, sampleData, sheet_name }) => {
  const handleExportToExcel = () => {

    const currentDate = new Date();

    const formattedDate = `${currentDate.getMonth() + 1}-${currentDate.getDate()}-${currentDate.getFullYear()}`;

    const ws = XLSX.utils.json_to_sheet(sampleData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, formattedDate);

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, `${sheet_name}.xlsx`);
  };

  return (
    <Modal
      show={open}
      onHide={onClose}
      size="lg"
      centered
      aria-labelledby="excel-preview-modal"
    >
      <Modal.Header closeButton>
        <div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
        <Modal.Title><img alt="svgImg" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiPiAgICA8cGF0aCBkPSJNIDE0IDMgTCAyIDUgTCAyIDE5IEwgMTQgMjEgTCAxNCAxOSBMIDIxIDE5IEMgMjEuNTUyIDE5IDIyIDE4LjU1MiAyMiAxOCBMIDIyIDYgQyAyMiA1LjQ0OCAyMS41NTIgNSAyMSA1IEwgMTQgNSBMIDE0IDMgeiBNIDEyIDUuMzYxMzI4MSBMIDEyIDE4LjYzODY3MiBMIDQgMTcuMzA2NjQxIEwgNCA2LjY5MzM1OTQgTCAxMiA1LjM2MTMyODEgeiBNIDE0IDcgTCAxNiA3IEwgMTYgOSBMIDE0IDkgTCAxNCA3IHogTSAxOCA3IEwgMjAgNyBMIDIwIDkgTCAxOCA5IEwgMTggNyB6IE0gNS4xNzU3ODEyIDguMjk2ODc1IEwgNy4wNjA1NDY5IDExLjk5NDE0MSBMIDUgMTUuNzAzMTI1IEwgNi43MzYzMjgxIDE1LjcwMzEyNSBMIDcuODU5Mzc1IDEzLjMwODU5NCBDIDcuOTM0Mzc1IDEzLjA3OTU5NCA3Ljk4NDc2NTYgMTIuOTA4OTIyIDguMDA5NzY1NiAxMi43OTQ5MjIgTCA4LjAyNTM5MDYgMTIuNzk0OTIyIEMgOC4wNjYzOTA2IDEzLjAzMjkyMiA4LjExNjIwMzEgMTMuMjAyMTA5IDguMTU4MjAzMSAxMy4yODcxMDkgTCA5LjI3MTQ4NDQgMTUuNzAxMTcyIEwgMTEgMTUuNzAxMTcyIEwgOS4wMDU4NTk0IDExLjk2Njc5NyBMIDEwLjk0MzM1OSA4LjI5Njg3NSBMIDkuMzIyMjY1NiA4LjI5Njg3NSBMIDguMjkyOTY4OCAxMC40OTQxNDEgQyA4LjE5Mjk2ODggMTAuNzc5MTQxIDguMTI1Nzk2OSAxMC45OTg2MjUgOC4wOTE3OTY5IDExLjE0MDYyNSBMIDguMDY2NDA2MiAxMS4xNDA2MjUgQyA4LjAwODQwNjMgMTAuOTAyNjI1IDcuOTUwOTUzMSAxMC42OTI3MTkgNy44NzY5NTMxIDEwLjUxMTcxOSBMIDYuOTUzMTI1IDguMjk2ODc1IEwgNS4xNzU3ODEyIDguMjk2ODc1IHogTSAxNCAxMSBMIDE2IDExIEwgMTYgMTMgTCAxNCAxMyBMIDE0IDExIHogTSAxOCAxMSBMIDIwIDExIEwgMjAgMTMgTCAxOCAxMyBMIDE4IDExIHogTSAxNCAxNSBMIDE2IDE1IEwgMTYgMTcgTCAxNCAxNyBMIDE0IDE1IHogTSAxOCAxNSBMIDIwIDE1IEwgMjAgMTcgTCAxOCAxNyBMIDE4IDE1IHoiLz48L3N2Zz4="/> &nbsp;</Modal.Title>
        &nbsp;
        <Typography variant="h6" fontWeight="bold">    
            Preview
        </Typography>
        </div>
      </Modal.Header>
      <Modal.Body>
        <TableContainer component={Paper} sx={{ boxShadow: 2 }}>
          <Table stickyHeader aria-label="excel preview table">
            <TableHead>
              <TableRow
                sx={{
                  bgcolor: "primary.light",
                  "& th": { color: "#000000", fontWeight: "bold" },
                }}
              >
                <TableCell>NIC</TableCell>
                <TableCell>Student Name</TableCell>
                <TableCell>Gender</TableCell>
                <TableCell>Contact Address</TableCell>
                <TableCell>Permanent Address</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Contact Phone</TableCell>
                <TableCell>Home Phone</TableCell>
                <TableCell>Medium</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sampleData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:nth-of-type(even)": { bgcolor: "grey.100" },
                    "&:hover": { bgcolor: "grey.200" },
                  }}
                >
                  <TableCell>{row.Nic ? row.Nic : "-"}</TableCell>
                  <TableCell>
                    {row["Student Name"] ? row["Student Name"] : "-"}
                  </TableCell>
                  <TableCell>{row.Gender ? row.Gender : "-"}</TableCell>
                  <TableCell>
                    {row["Contact Address"] ? row["Contact Address"] : "-"}
                  </TableCell>
                  <TableCell>
                    {row["Permanent Address"] ? row["Permanent Address"] : "-"}
                  </TableCell>
                  <TableCell>{row.Email ? row.Email : "-"}</TableCell>
                  <TableCell>
                    {row["Contact Phone"] ? row["Contact Phone"] : "-"}
                  </TableCell>
                  <TableCell>
                    {row["Home Phone"] ? row["Home Phone"] : "-"}
                  </TableCell>
                  <TableCell>{row.Medium ? row.Medium : "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Modal.Body>
      <Modal.Footer>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<DownloadIcon />}
          onClick={handleExportToExcel}
          style={{ backgroundColor: '#217346', borderColor: '#217346', color: 'white' }}
        >
          Export
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExcelPreviewModal;
